import GET_RETAIL_ZONE_LIST from './getRetailZoneList.graphql'
export default GET_RETAIL_ZONE_LIST
